import { useEffect } from 'react';

export const useReadyNotifier = () => {
  useEffect(() => {
    const sendReadyMessage = () => {
      window.parent.postMessage({ type: 'ready', payload: true }, '*');
    };

    sendReadyMessage();

    return () => {
      window.removeEventListener('load', sendReadyMessage);
    };
  }, []);
};
